/**
 * This file provides the custom settings for ChartJS
 */
let settings = {
    // Pie & Doughnut
    colors: [
        '#003366', // Dark Blue
        '#737B82', // Gray
        '#008571', // Teal (greenish blue)
        '#008DD2', // Sky Blue (lighter blue)
        '#ACC9CD', // Light Blue Gray
        '#490A71', // Dark Purple
        '#0041AC', // Blue
        '#000000', // Black
        '#1D8035', // Green
        '#005059', // Dark Teal
        '#825D02', // Brown
        '#AD8C00', // Gold
        '#7A2499', // Purple
        '#4A1165', // Deep Purple
        '#29C5A9', // Turquoise
        '#5677B0', // Steel Blue
        '#007A50', // Forest Green
    ],
    // Bar & Grouped Charts
    barColors: [
        '#003366',
        '#007DBB',
        '#737B82',
        '#008571', 
        '#CB4700', 
        '#2E7098',
    ],
    lightBarColors: [
        '#FFA415',
        '#FFA415',
        '#FFA415',
        '#FFA415', 
        '#FFA415', 
        '#FFA415',
    ],
    // Stacked Bar Charts
    stackedBarColors: [
        '#003366',
        '#FFA415',
        '#737B82',
        '#008571', 
        '#CB4700', 
        '#2E7098',
    ],
    lightStackedBarColors: [
        '#003366',
        '#007DBB',
        '#008571', 
        '#737B82',
        '#CB4700', 
        '#2E7098',
    ],
    // Stacked Bar Charts
    stackedBarKeyMetricsColors: [
        '#003366',
        '#FFA415',
        '#003366',
        '#FFA415', 
        '#FFA415', 
        '#FFA415',
    ],
    // CAGR Charts
    cagrBarColors: [
        '#2E7098',
        '#007780',
        '#80BBBF', 
        '#490A71',
        '#008A00', 
        '#CB4700',
    ],
    // Line Charts
    lineColors: [
        '#2E7098',
        '#008A00',
        '#CB4700',
        '#490A71',
        '#2E7098', 
        '#0041AC',
    ],
    // Line Chart Point Styles
    pointStyles: [
        'circle',
        'rect',
        'triangle',
        'star',
        'rhombus',
        'pentagon',
        'cross',
        'crossRot',
        'rectRot',
        'line',
        'rectRounded',
        'dash',
    ],
    rotation: 0,
    cutout: '50%',
    legendPosition: 'bottom',
    legendAlign: 'start',
    abbreviateNumber: true,
    pointRadius: 5,
    pointBorderWidth: 4,
    cubicInterpolationMode: 'monotone',
    font_family: "'Mulish', sans-serif",
    axisLabelColor: '#555555',
};
/* Setup config data for the charts
 * 'cd' is the JSON config data provided by the Chart class
 * 'pcd' is the prepared config data that is sent to Chart.js
 */
function prep_config(cd) {
    let pcd = {};
    pcd.type = cd.type;
    let monotype = cd.datasets.map(dataset => dataset.type).every(value => value === cd.datasets[0].type);
    
    jq.each(cd.datasets, function(index, value) {
        if (pcd.type === 'bar') {
            // Determine the color setting based on conditions
            let colorSetting = settings['barColors']; // Default color setting
            if (cd.stacked === 1) {
                if (cd.id == 23804) {
                    colorSetting = settings['stackedBarKeyMetricsColors']; // Default key metrics color setting
                } else if (cd.id == 23701) {
                    colorSetting = settings['lightStackedBarColors'];
                } else if (cd.id == 23794) {
                    console.log('lightBarColors');
                    colorSetting = settings['lightBarColors'];
                } else {
                    colorSetting = settings['stackedBarColors'];
                }
            } else if (cd.cagr === 1) {
                colorSetting = settings['cagrBarColors'];
            }

            if (cd.id == 23794) {
                colorSetting = settings['lightBarColors'];
            }
        
            // Apply the determined color setting
            (function() {
                var baseColor = colorSetting[index];
                var lastBarColor = '#003366';
                var dataPoints = (cd.datasets[index] && cd.datasets[index].data) ? cd.datasets[index].data.length : 0;
                if (cd.id == 23804 && dataPoints > 0) {
                    var bgColors = new Array(dataPoints).fill(baseColor);
                    var hoverBgColors = new Array(dataPoints).fill(baseColor);
                    bgColors[dataPoints - 1] = lastBarColor;
                    hoverBgColors[dataPoints - 1] = lastBarColor;
                    cd.datasets[index]['backgroundColor'] = bgColors;
                    cd.datasets[index]['hoverBackgroundColor'] = hoverBgColors;
                } else {
                    cd.datasets[index]['backgroundColor'] = baseColor;
                    cd.datasets[index]['hoverBackgroundColor'] = baseColor;
                }
            })();
 
            // Revert order so that the first dataset is the first to be drawn (for mixed charts)
            if (!monotype) {
                cd.datasets[index]['order'] = cd.datasets.length - index;
            }
            if (value.type == 'Line') {
                cd.datasets[index]['type'] = 'line';
                cd.datasets[index]['borderColor'] = settings['barColors'][index];
            }
        } else if (pcd.type === 'line') {
            cd.datasets[index]['borderColor'] = settings['lineColors'][index];
            cd.datasets[index]['pointBackgroundColor'] = '#FFFFFF';
            cd.datasets[index]['pointBorderColor'] = settings['lineColors'][index];
            cd.datasets[index]['pointBorderWidth'] = 2;
            cd.datasets[index]['pointStyle'] = settings['pointStyles'][index];
            
            // Prevent colors from changing on hover
            cd.datasets[index]['hoverBorderWidth'] = 2;
            cd.datasets[index]['hoverBackgroundColor'] = '#FFFFFF';
        } else {
            cd.datasets[index]['backgroundColor'] = settings['colors'];
        }
        if (pcd.type === 'pie' || pcd.type === 'doughnut') {
            // Set backgroundColor and borderColor for pie chart segments
            cd.datasets[index]['backgroundColor'] = settings['colors'];
            cd.datasets[index]['borderColor'] = "#FFFFFF";
            cd.datasets[index]['borderWidth'] = 3;

            // Prevent colors from changing on hover
            cd.datasets[index]['hoverBackgroundColor'] = settings['colors'];
            cd.datasets[index]['hoverBorderColor'] = "#FFFFFF";
        }
    });
    
    // Add in the chart data
    pcd.data = {
        labels: cd.labels,
        datasets: cd.datasets
    };
    pcd.labels = cd.labels;
    
    // Global chart options
    let baseOptions = {
        spanGaps: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                enabled: false,
                position: 'average',
                external: externalTooltipHandler,
            }
        },
        rotation: settings.rotation,
        cutout: cd.type === 'doughnut' ? settings.cutout : '0',
        unit: cd.unit,
        custom_unit: cd.custom_unit,
        chart_height: cd.chart_height,
        hide_x_axis_unit: cd.hide_x_axis_unit,
        hide_legend_unit: cd.hide_legend_unit,
        hide_tooltip_unit: cd.hide_tooltip_unit,
        hide_data_labels_unit: cd.hide_data_labels,
        tick_steps: cd.tick_steps,
        extra_tick_space: cd.extra_tick_space,
        y_axis_max: cd.y_axis_max,
    };

    const showYGrid = () => !['23804', '23794'].includes(cd.id)
    const showYAxisLabels = showYGrid;
      
    // Default scales options, which may be overridden based on the chart type
    let scalesOptions = {
        x: {
            border: {
                display: false,
                borderColor: 'transparent',
                borderWidth: 0
            },
            ticks: {
                callback: function(value, index, values) {
                    // If a chart is using full month names as labels -
                    // This function will automatically abbreviate it in the x-axis labels
                    const monthAbbreviations = {
                        'January': 'Jan', 'February': 'Feb', 'March': 'Mar', 'April': 'Apr',
                        'May': 'May', 'June': 'Jun', 'July': 'Jul', 'August': 'Aug',
                        'September': 'Sep', 'October': 'Oct', 'November': 'Nov', 'December': 'Dec'
                    };
                    const label = this.getLabelForValue(value);
                    return monthAbbreviations[label] || label;
                },
                font: {
                    family: settings.font_family,
                },
                color: settings.axisLabelColor
            },
        },
        y: {
            beginAtZero: true,
            min: 0,
            ticks: {
                font: {
                    family: settings.font_family
                },
                color: settings.axisLabelColor,
                display: showYAxisLabels(),
            },
            grid: {
                display: showYGrid()
            }
        }
    };
    
    // Calculate the maximum value across all datasets for dynamic yAxisMax
    let maxDataValue = Math.max(...pcd.data.datasets.map(dataset => Math.max(...dataset.data)));
    
    // Set tick steps with a default of 50 if none provided
    cd.tick_steps = cd.tick_steps || 50;
    
    // Function to calculate yAxisMax with optional extra space
    const calculateYAxisMax = (maxValue, tickStep, addExtraSpace, userMaxValue) => {
        let baseMax = Math.ceil(Number(maxValue) / Number(tickStep)) * Number(tickStep);
        let extraSpaceFactor = 0; // Initialize with no extra space
    
        // Determine extra space factor based on conditions
        if (addExtraSpace) {
            extraSpaceFactor = cd.stacked === 1 ? 3 : 1; // Triple space for stacked if extra space is requested, otherwise just one tickStep
        } else {
            extraSpaceFactor = cd.stacked === 1 ? 2 : 0; // Double space for stacked by default, no extra space otherwise
        }
    
        // Calculate final value by adding the calculated extra space to baseMax
        let calculatedMax = baseMax + (Number(tickStep) * extraSpaceFactor);
        
        // If y_axis_max is provided and it's greater than the base max, use it instead
        if (userMaxValue && Number(userMaxValue) > baseMax) {
            return Number(userMaxValue);
        }
        
        return calculatedMax;
    };
    
    // Determine if extra space should be added
    let addExtraSpace = cd.extra_tick_space === 1;
    
    // Customize options based on the chart type
    switch (cd.type) {
        case 'line':
            scalesOptions.y.ticks.stepSize = cd.tick_steps;
            scalesOptions.y.max = calculateYAxisMax(maxDataValue, cd.tick_steps, addExtraSpace, cd.y_axis_max);
            scalesOptions.x.grid = { display: false };
            cd.datasets.forEach(dataset => {
                dataset.pointHoverRadius = settings.pointRadius; // Prevents point icons from expanding on hover
                dataset.borderWidth = 2; // Set line thickness to 2px
            });
            break;
        case 'bar':
            scalesOptions.y.ticks.stepSize = cd.tick_steps;
            scalesOptions.y.max = calculateYAxisMax(maxDataValue, cd.tick_steps, addExtraSpace, cd.y_axis_max);
            scalesOptions.y.border = {
                display: false,
                borderColor: 'transparent',
                borderWidth: 0
            };
            break;
    }
    
    // Merge the scales options into the base options
    baseOptions.scales = scalesOptions;
   
    // Assign the merged options to pcd.options
    pcd.options = baseOptions;
    
    // Add titles to X and Y scales if provided
    if (cd.x_axis_title) {
        pcd.options.scales.x.title = {
            display: false,
            text: cd.x_axis_title,
            color: settings.axisLabelColor,
            font: {
                family: settings.font_family,
                weight: 'bold'
            }
        }
    }
    if (cd.y_axis_title) {
        pcd.options.scales.y.title = {
            display: true,
            text: cd.y_axis_title,
            color: settings.axisLabelColor,
            font: {
                family: settings.font_family,
                weight: 'bold'
            }
        }
    }
        
    // Legend plugin
    let legend_wrapper_id = `chart-${cd.row_id}-${cd.id}-legend`;
    let legend_wrapper_type = jq('#' + legend_wrapper_id).attr('data-type');
    pcd.options.plugins.legend = {
        display: false,
    }
    if (cd.type == 'pie' || cd.type == 'doughnut') {
        pcd.options.scales.x.display = false;
        pcd.options.scales.y.display = false;
        pcd.plugins = [htmlLegendPlugin];
        pcd.options.plugins.htmlLegend = {
            containerID: `chart-${cd.row_id}-${cd.id}-legend`,
            type: legend_wrapper_type,
        }
        pcd.options.plugins.datalabels = {
            display: false, 
        }
    } else if (cd.type == 'bar') {
        pcd.options.scales.x.grid = {
            display: false,
        }
        // Control bar width
        //pcd.options.maxBarThickness = 50; // Maximum width in pixels
        pcd.options.categoryPercentage = 1; // Percentage of available space (0-1)
        pcd.options.barPercentage = 0.95; // Percentage of category space (0-1)
        pcd.options.plugins.datalabels = {
            display: cd.hide_data_labels == 1 ? false : true, // Enable labels
            anchor: 'end',
            align: function(context) {
                // If there's more than one dataset, align the top one to 'bottom'
                if (pcd.data.datasets.length > 1 && context.datasetIndex !== pcd.data.datasets.length - 1) {
                    return 'bottom';
                }
                return 'top';
            },
            color: function(context) {
                // If there's more than one dataset, use white color for the top one
                if (pcd.data.datasets.length > 1 && (context.datasetIndex === 0)) {
                    return '#fff';
                }
                if (pcd.data.datasets.length > 1 && context.datasetIndex === 1) {
                    if(cd.id == 23701) {
                        return '#fff'
                    }
                    return '#000';
                }
                if (cd.id == 23701 && context.datasetIndex !== pcd.data.datasets.length - 1) {
                    return '#fff';
                }
                return '#000';
            },
            font: {
                family: settings.font_family,
                size: window.innerWidth < 767 ? 9 : 12,
                weight: 'bold'
            },
            formatter: function (value, context) {
                // Show billion suffix for specific charts.
                if(['23794'].includes(cd.id)) {
                    return value ? '$' + value +'b' : value;
                }
                return  value?'$' + value:value; // or format with cd.unit if needed
            }
        };
        if (pcd.data.datasets.length > 1 && !cd.cagr) {
            pcd.plugins = [htmlLegendPlugin];
            pcd.options.plugins.htmlLegend = {
                containerID: `chart-${cd.row_id}-${cd.id}-legend`,
                type: legend_wrapper_type
            }
        }
        if (cd.cagr) {
            // Set the bar data to the second dataset to apper behind the cagr line
            pcd.data.datasets[1] = pcd.data.datasets[0];
            // Calculate CAGR
            let dataPoints = pcd.data.datasets[0].data.length;
            let increment = (pcd.data.datasets[0].data[dataPoints - 1] - pcd.data.datasets[0].data[0]) / (dataPoints - 1);
            let cagr = [];
            for (let i = 0; i < dataPoints; i++) {
                cagr[i] = i === 0 ? parseFloat(pcd.data.datasets[0].data[i]) : cagr[i - 1] + increment;
            }
            
            // Set CAGR Line chart
            pcd.data.datasets[0] = {
                data: cagr,
                type: 'line',
                borderColor: '#000',
                borderOpacity: 1,
                rotate: 0.5,
                pointRadius: 0
            };
            
            // Define slope
            let slope;
            
            pcd.data.datasets[0].datalabels = {
                display: true,
                align: 'center',
                padding: {
                    top: 5,
                    right: 10,
                    bottom: 5,
                    left: 10
                },
                borderRadius: 10,
                rotation: function(context) {
                    var dataset = context.dataset;
                    if (dataset.rotate !== undefined) {
                        return dataset.rotate;
                    }
                    return 0;
                },
                formatter: function(value, context) {
                    if (context.dataIndex === Math.floor(context.dataset.data.length / 2)) {
                        // Calculate the number of periods (n) correctly as one less than the number of data points
                        let periods = context.dataset.data.length - 1;
                
                        // Calculate CAGR value
                        let cagrValue = (Math.pow((context.dataset.data[periods] / context.dataset.data[0]), (1 / periods)) - 1) * 100;
                
                        // Check if CAGR value is an integer or has a decimal
                        const isInteger = cagrValue % 1 === 0;
                
                        // Format CAGR value based on whether it is an integer
                        const formattedCagrValue = isInteger ? cagrValue.toFixed(0) : cagrValue.toFixed(2);
                
                        return formattedCagrValue + "% CAGR";
                    } else {
                        return null;
                    }
                },
                backgroundColor: function(context) {
                    if (context.dataIndex === Math.floor(context.dataset.data.length / 2)) {
                        return '#80BBBF'; // CAGR Background Color
                    } else {
                        return 'transparent';
                    }
                },
                borderColor: function(context) {
                    if (context.dataIndex === Math.floor(context.dataset.data.length / 2)) {
                        return '#80BBBF'; // CAGR Border Color
                    } else {
                        return 'transparent';
                    }
                },
                color: function(context) {
                    if (context.dataIndex === Math.floor(context.dataset.data.length / 2)) {
                        return '#000000'; // CAGR Text Color
                    } else {
                        return 'transparent';
                    }
                }                
            }
            pcd.data.datasets[1].datalabels = {
                display: false
            }
            
        } else {
            // Data Labels Plugin
            pcd.options.layout = {
                padding: {
                    top: 20
                }
            }
        }
    } else {
        pcd.options.plugins.datalabels = {
            display: false
        }
        pcd.options.pointRadius = settings.pointRadius;
        pcd.options.pointBorderWidth = settings.pointBorderWidth;
        pcd.options.pointHoverRadius = settings.pointRadius + 5;
        pcd.options.cubicInterpolationMode = settings.cubicInterpolationMode;
        pcd.plugins = [htmlLegendPlugin];
        pcd.options.plugins.htmlLegend = {
            containerID: `chart-${cd.row_id}-${cd.id}-legend`,
            type: legend_wrapper_type
        }
    }
    
    pcd.options.scales.y.ticks.callback = (value, index, values) => {
        let baseNum;
     
        // Determine the base number based on conditions
        if (value === 0) {
            baseNum = '0';
        } else  if (cd.unit === 'billion' && value < 1) {
            baseNum = (value * 1000).toFixed(0);
        } else if (settings.abbreviateNumber && !cd.custom_unit) {
            baseNum = abbreviateNumber(value);
        } else {
            baseNum = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    
        // Early return for special units: currency or percentage
        if (cd.unit == 'currency') {
            if (cd.hide_x_axis_unit == 1) {
                return baseNum;
            } else {
                return '$' + baseNum;
            }
        } else if (cd.unit == 'percentage') {
            if (cd.hide_x_axis_unit == 1) {
                return baseNum;
            } else {
                return baseNum + '%';
            }
        } else if  (cd.custom_unit) {
            if (cd.hide_x_axis_unit == 1) {
                return baseNum;
            } else {
                return baseNum + cd.custom_unit;
            }
        }
    
        // Check if x-axis unit should be hidden
        if (cd.hide_x_axis_unit == 1) {
            return baseNum;
        }
    
        // Determine the suffix based on the unit and conditions
        let suffix = '';
        if (value !== 0) { // Avoid appending suffix for 0 value
            if (cd.unit === 'billion' && value < 1) {
                suffix = 'm';
            } else if (cd.unit === 'million') {
                suffix = 'm';
            } else if (cd.unit === 'billion') {
                suffix = 'b';
            }
        }
    
        // Return the base number with the appropriate suffix
        baseNum = baseNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return baseNum + suffix;
    };
    
    // Setup stacked bars
    pcd.options.scales.x.stacked = cd.stacked == 1;
    pcd.options.scales.y.stacked = cd.stacked == 1;
    
    return pcd;
}

document.addEventListener("DOMContentLoaded", (event) => {
    let chart_groups = [];
    document.querySelectorAll('.module-charts').forEach((chart_group, index) => {
        let data = JSON.parse(document.getElementById(`charts-data-${chart_group.dataset.row}`).innerText);
        chart_groups.push(data);
        chart_groups[index].id = chart_group.dataset.row;
    });
    // Register data labels plugin
    Chart.register(ChartDataLabels);
    
    chart_groups.forEach((charts_data) => {
        let row_id = charts_data.id;
        charts_data.all_data.forEach((cd) => {
            cd.row_id = row_id;
            let el = document.getElementById(`chart-${row_id}-${cd.id}`);
            let chart_config = prep_config(cd);
            
            if (el) {
                // Determine height based on chart type if cd.chart_height is not specified
                let chart_height = cd.chart_height;
                if (!chart_height) {
                    switch (cd.type) {
                        case 'pie':
                        case 'doughnut':
                            chart_height = 270;
                            break;
                        case 'bar':
                            chart_height = 340;
                            break;
                        case 'line':
                            chart_height = 600;
                            break;
                        default:
                            chart_height = 600;
                    }
                }
                
                // Set the height of the canvas element
                el.height = chart_height;
                
                // Create the chart
                let myChart = new Chart(el, chart_config);

                // Dispatch chart initialized event
                document.body.dispatchEvent(new CustomEvent('chart-initialized', { detail: { id: cd.id, chart: myChart } }));
                
                // Rotate label if has CAGR Label
                let first_dataset = chart_config.data.datasets[0];
                if (cd.cagr) {
                    setTimeout(function() {
                        let dataPoints = first_dataset.data.length;
                        slope = (myChart.getDatasetMeta(0).data[dataPoints - 1].y - myChart.getDatasetMeta(0).data[0].y) / (myChart.getDatasetMeta(0).data[dataPoints - 1].x - myChart.getDatasetMeta(0).data[0].x);
                        let angle = Math.atan(slope) * (180 / Math.PI);
                        chart_config.data.datasets[0].datalabels.rotation = angle;
                        myChart.update();
                    }, 500);
                }
            }
        });
    });
    
    // Add resize event listener to update chart font sizes dynamically
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            // Update all charts when window is resized
            Chart.helpers.each(Chart.instances, function(chart) {
                if (chart.config.type === 'bar' && chart.config.options.plugins.datalabels) {
                    // Update font size based on current window width
                    const newFontSize = window.innerWidth < 767 ? 9 : 12;
                    chart.config.options.plugins.datalabels.font.size = newFontSize;
                    chart.update('none'); // Update without animation for better performance
                }
            });
        }, 100); // Debounce resize events
    });
});

// Function to abbreviate a number to its power of 10's suffix
function abbreviateNumber(number) {
    const SI_SYMBOL = ["", "K", "M", "B", "t", "q", "Q"];
    let tier = Math.log10(Math.abs(number)) / 3 | 0;
    
    if (tier < 2) {
        return number;
    }

    let suffix = SI_SYMBOL[tier];
    let scale = Math.pow(10, tier * 3);
    let scaled = number / scale;
    
    return scaled.toFixed(0) + suffix;
}